import * as designTokens from './generated/variables';
export const tokens = {
  ...designTokens,
};
export * from './theme';
export * as DesignSystem from './types';
